import { render, staticRenderFns } from "./bm.vue?vue&type=template&id=90687382&scoped=true"
import script from "./bm.vue?vue&type=script&lang=js"
export * from "./bm.vue?vue&type=script&lang=js"
import style0 from "./bm.vue?vue&type=style&index=0&id=90687382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90687382",
  null
  
)

export default component.exports